module.exports = __webpack_public_path__ + "2eea4ece81f6bffa68fc64878bd39108.svg";